import { formatDistanceStrict } from 'date-fns';

export const getTimeAgo = (timestamp: string) =>
  formatDistanceStrict(new Date(timestamp), new Date(), {});
